import Layout from '@/layout';
var travelOrderRouter = {
  path: '/travelOrder',
  component: Layout,
  redirect: '/travelOrder/stay',
  name: 'TravelOrder',
  meta: {
    title: '旅居订单',
    icon: 'clipboard'
  },
  children: [{
    path: 'stay',
    name: 'TravelOrderStay',
    component: function component() {
      return import('@/views/order/travel/stay');
    },
    meta: {
      title: '旅居订单',
      icon: ''
    }
  }, {
    path: 'food',
    name: 'TravelOrderFood',
    component: function component() {
      return import('@/views/order/travel/food');
    },
    meta: {
      title: '美食订单',
      icon: ''
    }
  }, {
    path: 'tour',
    name: 'TravelOrderTour',
    component: function component() {
      return import('@/views/order/travel/tour');
    },
    meta: {
      title: '线路订单',
      icon: ''
    }
  }]
};
export default travelOrderRouter;